import gql from "graphql-tag";

export const conciergeShiftPerformance = gql`
  query conciergeShiftPerformance($installationId: ID, $shiftId: ID) {
    conciergeShiftPerformance(installationId: $installationId, shiftId: $shiftId) {
      timezone
      shiftId
      shiftName
      shiftDate
      startsAt
      endsAt
      isLive
      isDefault
      runners {
        userId
        name
        onShift
        parked
        retrieved
        avgDropOffMs
        avgPickupMs
        avgHandoverMs
        currentPlate
        currentStatus
      }
    }
  }
`;
